export const checkMobileNumber = (mobileNumber: string) => {
    let checkMobileNumber = mobileNumber.trim();
    if (checkMobileNumber.startsWith("04") && checkMobileNumber.length === 10) return true;
    if (checkMobileNumber.startsWith("4") && checkMobileNumber.length === 9) return true;
    return false;
};

export const formatMobileNumber = (mobileNumber: string) => {
    let checkMobileNumber = mobileNumber.trim();
    if (checkMobileNumber.startsWith("0")) {
        checkMobileNumber = checkMobileNumber.substring(1, checkMobileNumber.length);
    }
    return `+61${checkMobileNumber}`;
};

export const ValidateEmail = (email: string) => {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
      return (true)
    }
    return (false)
  }